import {Action} from '@ngrx/store';
import * as api from '../../../clients/benutzerverwaltung';

export const PAGE_STATE_RESET = '[BenutzerRollenPage] Page State reset';

export const NICHT_ANZUZEIGENDE_BENUTZER_SETZEN = '[BenutzerRollenPage] Benutzer die aus der Auswahl entfernt werden sollen setzen';
export const ROLLE_SETZEN = '[BenutzerRollenPage] Ausgewählte Rolle setzen';
export const SELEKTIERTE_BENUTZER = '[BenutzerRollenPage] Selektierte Benutzer IDs';

export const SETZE_INFO_BENUTZER_ANZEIGEN = '[BenutzerRollenPage] Info-Benutzer anzeigen Setzen';
export const SETZE_STANDARD_BENUTZER_ANZEIGEN = '[BenutzerRollenPage] Standard-Benutzer anzeigen Setzen';


// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}


// FUNKTIONSBEREICHE-ROLLE(N)
export class RolleSetzenAction implements Action {
    readonly type = ROLLE_SETZEN;

    constructor(public rolle: api.Rolle) {
    }
}


// BENUTZER
export class NichtAnzuzeigendeBenutzerSetzenAction implements Action {
    readonly type = NICHT_ANZUZEIGENDE_BENUTZER_SETZEN;

    constructor(public nichtAnzuzeigendeBenutzer: Array<any>) {
    }
}

export class SelektierteBenutzerAction implements Action {
    readonly type = SELEKTIERTE_BENUTZER;

    constructor(public payload: Array<string>) {
    }
}

export class SetzeInfoBenutzerAnzeigenAction implements Action {
    readonly type = SETZE_INFO_BENUTZER_ANZEIGEN;

    constructor(public payload: boolean) {
    }
}

export class SetzeStandardBenutzerAnzeigenAction implements Action {
    readonly type = SETZE_STANDARD_BENUTZER_ANZEIGEN;

    constructor(public payload: boolean) {
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    RolleSetzenAction
    | NichtAnzuzeigendeBenutzerSetzenAction
    | SelektierteBenutzerAction
    | PageStateResetAction
    | SetzeInfoBenutzerAnzeigenAction
    | SetzeStandardBenutzerAnzeigenAction
    ;
